import { render, staticRenderFns } from "./FuncionarioModule.vue?vue&type=template&id=41e747a2"
import script from "./FuncionarioModule.vue?vue&type=script&lang=js"
export * from "./FuncionarioModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports